import { Survey } from '../../models';
import { UniqueLinksForm } from '../types/unique-links-form.types';

export class UniqueLinksFormMapper {
  public fromSurvey(survey: Survey): UniqueLinksForm {
    return {
      sameSettingsForAllSurveys: false,
      uniqueLinksEnabled: !!survey.uniqueLinks?.enable,
      entryLinks: (survey.uniqueLinks?.items ?? []).map((item) => item.link),
    };
  }
}
